import {
  ONETRUST_SCRIPT_BASE_PATH_SELF_HOSTED,
  ONETRUST_SCRIPT_BASE_URL,
  ONETRUST_SCRIPT_NAME,
  ONETRUST_SCRIPT_PATH_PRODUCTION_INTERNALLY_HOSTED,
  ONETRUST_SCRIPT_PATH_TEST_INTERNALLY_HOSTED,
} from './onetrust.constants'
import { Stage } from '@otto-ec/eprivacy-shared'
import { OnetrustSiteConfig } from '../../ports'

export function getOnetrustSdkSrc(
  oneTrustSiteConfig: OnetrustSiteConfig,
  stage: Stage,
  useSelfHosting: boolean | undefined,
  /*                                                          */
  /*                                       */
  baseUrl: string = import.meta.env.BASE_URL
) {
  if (useSelfHosting) {
    const stagePath = stage === 'live' ? '' : '-develop'
    const oneTrustScriptPath =
      window.location.hostname === 'localhost'
        ? ONETRUST_SCRIPT_PATH_TEST_INTERNALLY_HOSTED
        : ONETRUST_SCRIPT_PATH_PRODUCTION_INTERNALLY_HOSTED

    return [
      `${baseUrl}${ONETRUST_SCRIPT_BASE_PATH_SELF_HOSTED}${stagePath}`,
      oneTrustSiteConfig.version,
      `${oneTrustScriptPath}${oneTrustSiteConfig.id}`,
      ONETRUST_SCRIPT_NAME,
    ].join('/')
  }
  return [
    ONETRUST_SCRIPT_BASE_URL,
    oneTrustSiteConfig.id,
    ONETRUST_SCRIPT_NAME,
  ].join('/')
}
